export const fetchWithCredentials: typeof fetch = (input, init) => {
  return globalThis.fetch(input, {
    ...init,
    credentials: 'include',
  })
}
